// Copyright ©️ 2026 eVolve MEP, LLC

import { Flex, Text } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

export const ManageRevitRolesNotes = () => (
  <Flex gap="xs" mt="lg" mb="lg">
    <EvolveIcon icon="Info" size="sm" inline color="primary" />
    <Text size="sm">
      This configuration is utilized in versions of EVOLVE Electrical/Mechanical versions 9.4 and newer.
    </Text>
  </Flex>
);
